import { connect } from 'react-redux'

import { setAuth } from '../actions'

import CompleteProfile from '../components/CompleteProfile'

import {
  getUserBrokerName,
  getUserFirstName,
  getUserLastName,
  getUserPhone,
  getUserPhoneExt,
  getUserTitle,
  getUserUsername,
  isAuthenticated,
} from '../selectors'

const mapStateToProps = state => ({
  brokerName: getUserBrokerName(state),
  firstName: getUserFirstName(state),
  isAuthenticated: isAuthenticated(state),
  lastName: getUserLastName(state),
  phone: getUserPhone(state),
  phoneExt: getUserPhoneExt(state),
  title: getUserTitle(state),
  username: getUserUsername(state),
})

const mapDispatchToProps = {
  setAuth,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompleteProfile)
